export const getLoginReturnPath = (state: unknown, fallback: string): string => {
  const from = (state as { from?: { pathname?: unknown; search?: unknown; hash?: unknown } } | null)?.from;
  if (typeof from?.pathname !== 'string' || !from.pathname.startsWith('/') ||
      from.pathname.startsWith('//') || /[\\\r\n]/.test(from.pathname) || from.pathname === '/login') return fallback;
  const search = typeof from.search === 'string' && from.search.startsWith('?') ? from.search : '';
  const hash = typeof from.hash === 'string' && from.hash.startsWith('#') ? from.hash : '';

  return `${from.pathname}${search}${hash}`;
};
